/* KISMET — theme.js (sin dependencias) */
(() => {
  'use strict';
  const K = window.KISMET || {};
  const $ = (s, c = document) => c.querySelector(s);
  const $$ = (s, c = document) => Array.from(c.querySelectorAll(s));
  const store = {
    get(k) { try { return window.localStorage.getItem(k); } catch (e) { return null; } },
    set(k, v) { try { window.localStorage.setItem(k, v); } catch (e) {} }
  };

  /* ---------------- Toast ---------------- */
  let toastT;
  function toast(msg) {
    const t = $('[data-toast]'); if (!t) return;
    t.textContent = msg; t.classList.add('is-visible');
    clearTimeout(toastT); toastT = setTimeout(() => t.classList.remove('is-visible'), 2600);
  }

  /* ---------------- Drawers ---------------- */
  const overlay = $('[data-overlay]');
  let openDrawerEl = null, lastFocus = null;
  function openDrawer(name) {
    const d = $(`[data-drawer="${name}"]`); if (!d) return false;
    if (openDrawerEl && openDrawerEl !== d) closeDrawer(true);
    lastFocus = document.activeElement;
    d.classList.add('is-open'); d.setAttribute('aria-hidden', 'false');
    if (overlay) { overlay.hidden = false; requestAnimationFrame(() => overlay.classList.add('is-visible')); }
    document.body.classList.add('is-locked');
    openDrawerEl = d;
    const focusable = d.querySelector('input[type=search], button, a[href]');
    setTimeout(() => focusable && focusable.focus({ preventScroll: true }), 60);
    if (name === 'cart') loadCartUpsell();
    return true;
  }
  function closeDrawer(silent) {
    if (!openDrawerEl) return;
    openDrawerEl.classList.remove('is-open'); openDrawerEl.setAttribute('aria-hidden', 'true');
    openDrawerEl = null;
    if (!silent && overlay) { overlay.classList.remove('is-visible'); setTimeout(() => { if (!openDrawerEl) overlay.hidden = true; }, 300); }
    document.body.classList.remove('is-locked');
    if (!silent && lastFocus) lastFocus.focus({ preventScroll: true });
  }
  document.addEventListener('click', (e) => {
    const opener = e.target.closest('[data-open]');
    if (opener) {
      const name = opener.getAttribute('data-open');
      if (openDrawer(name)) e.preventDefault();
      return;
    }
    if (e.target.closest('[data-close]') || e.target === overlay) { e.preventDefault(); closeDrawer(); }
  });
  document.addEventListener('keydown', (e) => { if (e.key === 'Escape') closeDrawer(); });

  /* ---------------- Header: autohide + mega ---------------- */
  const hdrSection = $('.section-header');
  const hdr = $('[data-header]');
  if (hdrSection && hdr && hdr.classList.contains('hdr--autohide')) {
    let lastY = window.scrollY;
    window.addEventListener('scroll', () => {
      const y = window.scrollY;
      if (openDrawerEl) return;
      if (y > lastY && y > 200) hdrSection.classList.add('is-hidden');
      else hdrSection.classList.remove('is-hidden');
      lastY = y;
    }, { passive: true });
  }
  $$('[data-mega]').forEach((item) => {
    const btn = $('[data-mega-trigger]', item);
    let t;
    const open = () => { clearTimeout(t); $$('[data-mega].is-open').forEach(o => o !== item && o.classList.remove('is-open')); item.classList.add('is-open'); btn.setAttribute('aria-expanded', 'true'); };
    const close = () => { t = setTimeout(() => { item.classList.remove('is-open'); btn.setAttribute('aria-expanded', 'false'); }, 120); };
    item.addEventListener('mouseenter', open);
    item.addEventListener('mouseleave', close);
    btn.addEventListener('click', () => item.classList.contains('is-open') ? (item.classList.remove('is-open'), btn.setAttribute('aria-expanded', 'false')) : open());
    item.addEventListener('keydown', (e) => { if (e.key === 'Escape') { item.classList.remove('is-open'); btn.focus(); } });
  });

  /* ---------------- Announcement rotator ---------------- */
  $$('[data-rotator]').forEach((r) => {
    const msgs = $$('.ann__msg', r); if (msgs.length < 2) return;
    let i = 0; const ms = (parseInt(r.dataset.interval, 10) || 4) * 1000;
    setInterval(() => {
      const cur = msgs[i]; i = (i + 1) % msgs.length; const nxt = msgs[i];
      cur.classList.add('is-leaving'); cur.classList.remove('is-active');
      nxt.classList.add('is-active');
      setTimeout(() => cur.classList.remove('is-leaving'), 500);
    }, ms);
  });

  /* ---------------- Countdowns ---------------- */
  function endTime(el) {
    if (el.dataset.mode === 'date' && el.dataset.end) {
      const d = new Date(el.dataset.end); if (!isNaN(d)) return d;
    }
    const d = new Date(); d.setHours(23, 59, 59, 999); return d;
  }
  const pad = n => String(n).padStart(2, '0');
  $$('[data-countdown]').forEach((el) => {
    const end = endTime(el);
    const clock = $('[data-clock]', el);
    const h = $('[data-cd="h"]', el), m = $('[data-cd="m"]', el), s = $('[data-cd="s"]', el);
    const tick = () => {
      let diff = Math.max(0, end - new Date());
      if (diff <= 0 && el.dataset.mode === 'date') { el.hidden = true; return false; }
      const hh = Math.floor(diff / 36e5), mm = Math.floor(diff % 36e5 / 6e4), ss = Math.floor(diff % 6e4 / 1e3);
      const dd = Math.floor(hh / 24);
      if (clock) clock.textContent = dd > 0 ? `${dd}d ${pad(hh % 24)}:${pad(mm)}:${pad(ss)}` : `${pad(hh)}:${pad(mm)}:${pad(ss)}`;
      if (h) h.textContent = pad(hh); if (m) m.textContent = pad(mm); if (s) s.textContent = pad(ss);
      return true;
    };
    if (tick()) { const iv = setInterval(() => { if (!tick()) clearInterval(iv); }, 1000); }
  });

  /* ---------------- Tabs ---------------- */
  $$('[data-tabs]').forEach((wrap) => {
    $$('[data-tab]', wrap).forEach((tab) => tab.addEventListener('click', () => {
      const id = tab.dataset.tab;
      $$('[data-tab]', wrap).forEach(t => { const on = t === tab; t.classList.toggle('is-active', on); t.setAttribute('aria-selected', on); });
      $$('[data-panel]', wrap).forEach(p => { const on = p.dataset.panel === id; p.hidden = !on; p.classList.toggle('is-active', on); });
    }));
  });

  /* ---------------- Cart ---------------- */
  const Cart = {
    async request(url, body) {
      const res = await fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) });
      const data = await res.json();
      if (!res.ok || data.status) throw new Error(data.description || data.message || 'Error');
      return data;
    },
    drawer() { return $('#CartDrawer'); },
    setLoading(on) { const d = this.drawer(); if (d) d.classList.toggle('is-loading', on); },
    render(sections) {
      const html = sections && sections['cart-drawer'];
      if (!html) return;
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const fresh = doc.querySelector('#CartDrawer');
      const cur = this.drawer();
      if (fresh && cur) {
        const wasOpen = cur.classList.contains('is-open');
        const upsell = $('[data-cart-upsell]', cur);
        const keepUpsell = upsell && upsell.dataset.loaded === 'true' ? upsell.innerHTML : null;
        const keepPid = upsell && upsell.dataset.productId;
        cur.innerHTML = fresh.innerHTML;
        ['data-real-count', 'data-has-prot', 'data-prot-key'].forEach(a => cur.setAttribute(a, fresh.getAttribute(a)));
        if (wasOpen) cur.classList.add('is-open');
        const nu = $('[data-cart-upsell]', cur);
        if (nu && keepUpsell && nu.dataset.productId === keepPid && !nu.children.length) { nu.innerHTML = keepUpsell; nu.dataset.loaded = 'true'; }
      }
      const count = cur ? parseInt(cur.getAttribute('data-real-count'), 10) || 0 : 0;
      $$('[data-cart-count]').forEach(c => { c.textContent = count; c.classList.remove('bump'); void c.offsetWidth; c.classList.add('bump'); });
      if (this.drawer() && this.drawer().classList.contains('is-open')) loadCartUpsell();
    },
    async add(items, opts = {}) {
      this.setLoading(true);
      try {
        const data = await this.request(K.routes.cartAdd, { items, sections: ['cart-drawer'], sections_url: window.location.pathname });
        this.render(data.sections);
        await this.syncProtection();
        if (opts.open !== false) openDrawer('cart');
        return data;
      } finally { this.setLoading(false); }
    },
    async change(key, quantity) {
      this.setLoading(true);
      try {
        const data = await this.request(K.routes.cartChange, { id: key, quantity, sections: ['cart-drawer'], sections_url: window.location.pathname });
        this.render(data.sections);
        await this.syncProtection();
        return data;
      } catch (e) { toast(e.message); } finally { this.setLoading(false); }
    },
    async syncProtection() {
      const P = K.protection; if (!P || !P.enabled || !P.variantId) return;
      const d = this.drawer(); if (!d) return;
      const real = parseInt(d.getAttribute('data-real-count'), 10) || 0;
      const has = d.getAttribute('data-has-prot') === 'true';
      const key = d.getAttribute('data-prot-key');
      const optOut = store.get('k_prot_off') === '1';
      if (real === 0 && has) {
        const data = await this.request(K.routes.cartChange, { id: key, quantity: 0, sections: ['cart-drawer'] }); this.render(data.sections);
      } else if (real > 0 && !has && P.defaultOn && !optOut) {
        const data = await this.request(K.routes.cartAdd, { items: [{ id: P.variantId, quantity: 1 }], sections: ['cart-drawer'] }); this.render(data.sections);
      }
    }
  };
  window.KISMET.cart = Cart;

  async function loadCartUpsell() {
    const box = $('#CartDrawer [data-cart-upsell]');
    if (!box || box.children.length || box.dataset.loading === 'true') return;
    const pid = box.dataset.productId; if (!pid) return;
    box.dataset.loading = 'true';
    try {
      const res = await fetch(`${K.routes.recommendations}?section_id=cart-upsell&product_id=${pid}&limit=8&intent=related`);
      const html = await res.text();
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const inner = doc.querySelector('.shopify-section') || doc.body;
      if (inner && inner.textContent.trim()) { box.innerHTML = inner.innerHTML; box.dataset.loaded = 'true'; }
    } catch (e) { /* sin recomendaciones */ } finally { box.dataset.loading = 'false'; }
  }

  document.addEventListener('click', async (e) => {
    const rm = e.target.closest('[data-cart-remove]');
    if (rm) { e.preventDefault(); Cart.change(rm.dataset.cartRemove, 0); return; }
    const q = e.target.closest('[data-cart-qty]');
    if (q) { e.preventDefault(); Cart.change(q.dataset.cartQty, Math.max(0, parseInt(q.dataset.qtyTo, 10))); return; }
    const qa = e.target.closest('[data-quick-add]');
    if (qa && !qa.disabled) {
      e.preventDefault();
      qa.classList.add('is-loading');
      try { await Cart.add([{ id: parseInt(qa.dataset.quickAdd, 10), quantity: 1 }]); toast(K.strings.added); }
      catch (err) { toast(err.message); }
      finally { qa.classList.remove('is-loading'); }
    }
  });
  document.addEventListener('change', async (e) => {
    if (e.target.matches('[data-protection-toggle]')) {
      const on = e.target.checked;
      store.set('k_prot_off', on ? '0' : '1');
      const d = Cart.drawer();
      if (on) { await Cart.add([{ id: K.protection.variantId, quantity: 1 }], { open: false }); }
      else { const key = d.getAttribute('data-prot-key'); if (key) await Cart.change(key, 0); }
    }
    if (e.target.matches('[data-cart-note]')) {
      fetch(K.routes.cartUpdate, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ note: e.target.value }) });
    }
  });
  if (K.protection && K.protection.enabled) {
    const d = Cart.drawer();
    if (d && parseInt(d.getAttribute('data-real-count'), 10) > 0) Cart.syncProtection().catch(() => {});
  }
  if (/[?&]cart=open/.test(location.search)) openDrawer('cart');

  /* ---------------- Product page ---------------- */
  $$('[data-product]').forEach((root) => {
    const jsonEl = $('[data-product-json]', root); if (!jsonEl) return;
    const data = JSON.parse(jsonEl.textContent);
    const form = $('[data-product-form]', root);
    const idInput = form && $('[data-variant-id]', form);
    const atc = $('[data-atc]', root);
    const atcLabel = $('[data-atc-label]', root);
    const atcPrice = $('[data-atc-price]', root);
    const sizeIdx = parseInt(root.dataset.sizeIndex, 10);
    const colorIdx = parseInt(root.dataset.colorIndex, 10);
    const requireSize = root.dataset.requireSize === 'true';
    const filterMedia = root.dataset.filterMedia === 'true';
    const picker = $('[data-variant-picker]', root);
    const sizeErr = $('[data-size-error]', root);
    const gallery = $('[data-gallery]', root);
    let needsSize = !!(idInput && idInput.dataset.needsSize === 'true');
    let current = data.variants.find(v => idInput && v.id === parseInt(idInput.value, 10)) || data.variants[0];

    const selected = () => {
      const opts = [];
      $$('.vp__opt', root).forEach((fs) => {
        const i = parseInt(fs.dataset.optionIndex, 10);
        const c = $('input:checked', fs); opts[i] = c ? c.value : null;
      });
      return opts;
    };
    const setAtc = (v) => {
      if (!atc) return;
      if (!v || !v.available) { atc.disabled = true; atcLabel.textContent = v ? K.strings.soldOut : K.strings.unavailable; }
      else if (needsSize) { atc.disabled = false; atcLabel.textContent = K.strings.pickSize; }
      else { atc.disabled = false; atcLabel.textContent = K.strings.addToCart; }
      if (v && atcPrice) atcPrice.textContent = v.price_fmt;
    };
    const updateAvailability = (opts) => {
      if (sizeIdx < 0) return;
      $$(`.vp__opt[data-option-index="${sizeIdx}"] .vp__val`, root).forEach((lab) => {
        const val = $('input', lab).value;
        const ok = data.variants.some(v => v.options[sizeIdx] === val && v.available && v.options.every((o, i) => i === sizeIdx || opts[i] == null || o === opts[i]));
        lab.classList.toggle('is-unavailable', !ok);
      });
    };
    const scrollToMedia = (mediaId) => {
      if (!gallery || !mediaId) return;
      const item = $(`[data-media-id="${mediaId}"]`, gallery); if (!item) return;
      if (window.matchMedia('(min-width: 990px)').matches) return;
      gallery.scrollTo({ left: item.offsetLeft, behavior: 'smooth' });
    };
    const applyColorFilter = (color) => {
      if (!filterMedia || !gallery || !color) return;
      const c = color.toLowerCase();
      const items = $$('.gal__item', gallery);
      const any = items.some(i => (i.dataset.mediaAlt || '').includes(c));
      items.forEach(i => i.classList.toggle('is-filtered', any && !(i.dataset.mediaAlt || '').includes(c)));
      updateDots();
    };
    const update = () => {
      const opts = selected();
      $$('[data-option-value]', root).forEach(el => { const i = parseInt(el.dataset.optionValue, 10); if (opts[i]) el.textContent = opts[i]; });
      updateAvailability(opts);
      needsSize = requireSize && sizeIdx >= 0 && !opts[sizeIdx];
      const probe = opts.map((o, i) => (o == null && i === sizeIdx) ? null : o);
      let v = data.variants.find(x => x.options.every((o, i) => probe[i] == null || o === probe[i]) && (probe[sizeIdx] != null || x.available)) ||
              data.variants.find(x => x.options.every((o, i) => probe[i] == null || o === probe[i]));
      current = v || null;
      if (v) {
        if (idInput) idInput.value = v.id;
        const now = $('[data-price-now]', root), was = $('[data-price-was]', root), chip = $('[data-price-chip]', root);
        if (now) now.textContent = v.price_fmt;
        const onSale = v.compare_at_price > v.price;
        if (was) { was.hidden = !onSale; was.textContent = v.compare_fmt; }
        if (chip) { chip.hidden = !onSale; chip.textContent = `-${Math.round((v.compare_at_price - v.price) * 100 / v.compare_at_price)}%`; }
        if (!needsSize) { const u = new URL(location.href); u.searchParams.set('variant', v.id); history.replaceState({}, '', u); }
        scrollToMedia(v.media_id);
        if (colorIdx >= 0) applyColorFilter(v.options[colorIdx]);
        const sm = $('[data-sticky-meta]', root); if (sm) sm.textContent = needsSize ? v.price_fmt : `${v.price_fmt} · ${v.options.join(' / ')}`;
      }
      if (sizeErr && !needsSize) sizeErr.hidden = true;
      setAtc(v);
    };
    if (picker) picker.addEventListener('change', update);
    if (picker) { const opts = selected(); updateAvailability(opts); if (colorIdx >= 0) applyColorFilter(opts[colorIdx]); }
    setAtc(current);

    const demandSize = () => {
      if (sizeErr) sizeErr.hidden = false;
      if (picker) { picker.classList.remove('shake'); void picker.offsetWidth; picker.classList.add('shake'); picker.scrollIntoView({ behavior: 'smooth', block: 'center' }); }
    };

    if (form) form.addEventListener('submit', async (e) => {
      e.preventDefault();
      if (needsSize) { demandSize(); return; }
      if (!current || !current.available) return;
      const qtyEl = $('input[name="quantity"]', form);
      const qty = qtyEl ? Math.max(1, parseInt(qtyEl.value, 10) || 1) : 1;
      atc.classList.add('is-loading'); atcLabel.textContent = K.strings.adding;
      try { await Cart.add([{ id: current.id, quantity: qty }]); }
      catch (err) { toast(err.message); }
      finally { atc.classList.remove('is-loading'); setAtc(current); }
    });

    $$('[data-qty]', root).forEach((q) => {
      const inp = $('input', q);
      $('[data-qty-minus]', q).addEventListener('click', () => { inp.value = Math.max(1, (parseInt(inp.value, 10) || 1) - 1); });
      $('[data-qty-plus]', q).addEventListener('click', () => { inp.value = (parseInt(inp.value, 10) || 1) + 1; });
    });

    /* Puntos y contador: se buscan dentro de la función porque el filtro por color la llama antes */
    function updateDots() {
      if (!gallery) return;
      const dots = $$('[data-gallery-dots] span', root);
      const counter = $('[data-gallery-count]', root);
      const vis = $$('.gal__item', gallery).filter(i => !i.classList.contains('is-filtered'));
      const idx = Math.round(gallery.scrollLeft / (gallery.clientWidth || 1));
      dots.forEach((d, i) => { d.hidden = i >= vis.length; d.classList.toggle('is-active', i === idx); });
      if (counter) counter.textContent = `${Math.min(idx + 1, vis.length)} / ${vis.length}`;
    }
    if (gallery) gallery.addEventListener('scroll', () => requestAnimationFrame(updateDots), { passive: true });

    const lb = $('#Lightbox', root);
    $$('[data-zoom]', root).forEach((b) => b.addEventListener('click', () => {
      if (!lb || typeof lb.showModal !== 'function') return;
      const imgIndex = $$('[data-zoom]', root).indexOf(b);
      lb.showModal();
      const track = $('[data-lightbox-track]', lb);
      track.scrollLeft = track.clientWidth * imgIndex;
    }));

    const sticky = $('[data-sticky-atc]', root);
    if (sticky && atc) {
      const io = new IntersectionObserver(([en]) => {
        const show = !en.isIntersecting && en.boundingClientRect.top < 0;
        sticky.classList.toggle('is-visible', show); sticky.setAttribute('aria-hidden', !show);
      });
      io.observe(atc);
      $('[data-sticky-btn]', sticky).addEventListener('click', () => {
        if (needsSize) { demandSize(); return; }
        form.requestSubmit ? form.requestSubmit() : form.dispatchEvent(new Event('submit', { cancelable: true }));
      });
    }

    const del = $('[data-delivery]', root);
    if (del) {
      const addBiz = (d, n) => { const r = new Date(d); let a = 0; while (a < n) { r.setDate(r.getDate() + 1); const w = r.getDay(); if (w !== 0 && w !== 6) a++; } return r; };
      const f = new Intl.DateTimeFormat('es-MX', { weekday: 'short', day: 'numeric', month: 'short' });
      const today = new Date();
      const a = addBiz(today, parseInt(del.dataset.min, 10) || 5), b = addBiz(today, parseInt(del.dataset.max, 10) || 9);
      const out = $('[data-delivery-range]', del);
      if (out) out.textContent = `entre el ${f.format(a)} y el ${f.format(b)}`;
    }

    const share = $('[data-share]', root);
    if (share) share.addEventListener('click', async () => {
      const url = share.dataset.url;
      if (navigator.share) { try { await navigator.share({ title: share.dataset.title, url }); } catch (e) {} }
      else if (navigator.clipboard) { await navigator.clipboard.writeText(url); toast('Enlace copiado'); }
    });
  });

  /* ---------------- Modals ---------------- */
  document.addEventListener('click', (e) => {
    const o = e.target.closest('[data-open-modal]');
    if (o) { const m = document.getElementById(o.dataset.openModal); if (m && m.showModal) m.showModal(); return; }
    const c = e.target.closest('[data-close-modal]');
    if (c) { const m = c.closest('dialog'); if (m) m.close(); return; }
    if (e.target.tagName === 'DIALOG') e.target.close();
  });

  /* ---------------- Recomendaciones ---------------- */
  $$('[data-recs]').forEach(async (box) => {
    try {
      const res = await fetch(box.dataset.url);
      const html = await res.text();
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const fresh = doc.querySelector('[data-recs]');
      if (fresh && fresh.querySelector('.card')) box.innerHTML = fresh.innerHTML;
    } catch (e) {}
  });

  /* ---------------- Colección ---------------- */
  const sort = $('[data-sort]');
  if (sort) sort.addEventListener('change', () => { const u = new URL(location.href); u.searchParams.set('sort_by', sort.value); u.searchParams.delete('page'); location.href = u; });
  const filtersForm = $('[data-filters]');
  if (filtersForm) filtersForm.addEventListener('submit', (e) => {
    e.preventDefault();
    const params = new URLSearchParams();
    new FormData(filtersForm).forEach((v, k) => { if (v !== '') params.append(k, v); });
    location.href = `${filtersForm.action}?${params.toString()}`;
  });
  const gridEl = $('[data-grid]');
  if (gridEl) {
    const btns = $$('[data-grid-cols]');
    const apply = (n) => {
      gridEl.classList.remove('is-cols-1', 'is-cols-2');
      const mobile = window.matchMedia('(max-width: 989px)').matches;
      if (n === '2') gridEl.classList.add(mobile ? 'is-cols-1' : 'is-cols-2');
      btns.forEach(b => b.classList.toggle('is-active', b.dataset.gridCols === n));
      store.set('k_grid', n);
    };
    btns.forEach(b => b.addEventListener('click', () => apply(b.dataset.gridCols)));
    const saved = store.get('k_grid'); if (saved) apply(saved);
  }
  document.addEventListener('click', async (e) => {
    const more = e.target.closest('[data-load-more]'); if (!more) return;
    e.preventDefault();
    more.textContent = 'Cargando…';
    try {
      const res = await fetch(more.href); const html = await res.text();
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const target = $('[data-products]');
      $$('[data-products] > *', doc).forEach(n => target.appendChild(n));
      const next = $('[data-load-more]', doc);
      const wrap = more.closest('.loadmore');
      const nwrap = next && next.closest('.loadmore');
      if (nwrap) wrap.replaceWith(nwrap); else wrap.remove();
      history.replaceState({}, '', more.href);
    } catch (err) { more.textContent = 'Cargar más'; }
  });

  /* ---------------- Búsqueda predictiva ---------------- */
  const pInput = $('[data-predictive-input]');
  const pResults = $('[data-predictive-results]');
  if (pInput && pResults) {
    const initial = pResults.innerHTML;
    let t, ctrl;
    pInput.addEventListener('input', () => {
      clearTimeout(t);
      const q = pInput.value.trim();
      if (!q) { pResults.innerHTML = initial; return; }
      t = setTimeout(async () => {
        if (ctrl) ctrl.abort(); ctrl = new AbortController();
        try {
          const res = await fetch(`${K.routes.predictive}?q=${encodeURIComponent(q)}&section_id=predictive-search&resources[type]=product,collection,query&resources[limit]=10`, { signal: ctrl.signal });
          const html = await res.text();
          const doc = new DOMParser().parseFromString(html, 'text/html');
          const s = doc.querySelector('.shopify-section');
          pResults.innerHTML = s ? s.innerHTML : html;
        } catch (e) {}
      }, 220);
    });
  }

  /* ---------------- Reels ---------------- */
  $$('[data-reel-play]').forEach((b) => b.addEventListener('click', () => {
    const reel = b.closest('.reel'); const v = $('video', reel); if (!v) return;
    if (v.paused) { $$('.reel video').forEach(o => { if (o !== v) { o.pause(); o.closest('.reel').classList.remove('is-playing'); } }); v.play(); reel.classList.add('is-playing'); }
    else { v.pause(); reel.classList.remove('is-playing'); }
  }));
  $$('.reel__media video').forEach(v => v.addEventListener('click', () => { v.pause(); v.closest('.reel').classList.remove('is-playing'); }));

  /* ---------------- Reveal ---------------- */
  if ('IntersectionObserver' in window) {
    const els = $$('.sec-head, .card, .cat, .bundle__step, .rev');
    const io = new IntersectionObserver((entries) => entries.forEach((en) => { if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); } }), { rootMargin: '0px 0px -8% 0px' });
    els.forEach((el, i) => { el.classList.add('reveal'); el.style.transitionDelay = `${(i % 4) * 60}ms`; io.observe(el); });
  }
})();